const SearchCount = ({ searchTerm, results }) => {
  return (
    <h5 className="search-count__text">
      Search Results for <span className="primary">{searchTerm}</span> ({results || '0'}{' '}
      {!results || results !== 1 ? 'results' : 'result'})
    </h5>
  )
}

export default SearchCount
